import React from 'react';

import type { RadioProps } from '@mui/material';
import { Radio } from '@mui/material';
import { RadioSelectedIcon } from 'src/components/icons/RadioSelectedIcon';
import { RadioUnselectedIcon } from 'src/components/icons/RadioUnselectedIcon';

export function AlineRadio(props: Omit<RadioProps, 'checkedIcon' | 'icon'>): JSX.Element {
  return <Radio checkedIcon={<RadioSelectedIcon />} icon={<RadioUnselectedIcon />} {...props} />;
}
